import React from 'react';
import BrandLogo from './BrandLogo';
import HamburgerButton from './HamburgerButton';
import SocialLinks from './SocialLinks';

const ModernHeader = ({ 
    searchString, 
    changeSearchKeyWord, 
    onBtnClick, 
    handleLoginShow, 
    loggedIn, 
    userEmail,
    viewMode,
    onViewModeChange,
    showHamburger,
    onToggleSidebar,
    sidebarOpen,
    searchError,
    connectionState
}) => {
    const sessionLabel = userEmail ? `Signed in as ${userEmail}` : 'Signed in';
    const sessionInitial = userEmail ? userEmail.trim().charAt(0).toUpperCase() : 'U';

    return (
        <header className="modern-header">
            <div className="header-brand">
                {showHamburger && (
                    <HamburgerButton 
                        isOpen={sidebarOpen}
                        onClick={onToggleSidebar}
                        className="header-hamburger"
                    />
                )}
                {loggedIn && (
                    <span
                        className="session-avatar"
                        role="img"
                        aria-label={sessionLabel}
                        title={sessionLabel}
                    >
                        {sessionInitial}
                    </span>
                )}
                <BrandLogo className="header-brand-logo" />
            </div>
            
            <form
                className="header-search"
                onSubmit={(event) => {
                    event.preventDefault();
                    onBtnClick();
                }}
            >
                <label className="sr-only" htmlFor="video-search">Search videos or paste a link</label>
                <input
                    id="video-search"
                    type="text"
                    role="searchbox"
                    inputMode="search"
                    className={`search-input${searchString ? ' has-clear' : ''}`}
                    placeholder="Search videos or paste a link"
                    value={searchString}
                    onChange={(e) => changeSearchKeyWord(e.target.value)}
                    aria-describedby={searchError ? 'search-error' : undefined}
                />
                {searchString ? (
                    <button
                        type="button"
                        className="search-clear-btn"
                        aria-label="Clear search"
                        onClick={() => changeSearchKeyWord('')}
                    >
                        ×
                    </button>
                ) : null}
                <button className="search-btn" type="submit" aria-label="Search">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                    </svg>
                </button>
                {searchError && <span className="header-search-error" id="search-error" role="alert">{searchError}</span>}
            </form>
            
            <div className="header-actions">
                {process.env.NODE_ENV !== 'production' && connectionState && (
                    <span
                        className={`connection-status${connectionState === 'connected' ? ' connected' : ''}`}
                        aria-live="polite"
                    >
                        <span className="status-dot" aria-hidden="true" />
                        {connectionState === 'connected'
                            ? 'Live'
                            : connectionState === 'connecting'
                                ? 'Connecting…'
                                : 'Offline'}
                    </span>
                )}

                <SocialLinks className="header-socials" />

                <div className="view-toggle">
                    <button 
                        type="button"
                        className={`toggle-btn ${viewMode === 'single' ? 'active' : ''}`}
                        onClick={() => onViewModeChange('single')}
                        aria-pressed={viewMode === 'single'}
                        title="Single player — one video at a time"
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                        </svg>
                        Single
                    </button>
                    <button 
                        type="button"
                        className={`toggle-btn ${viewMode === 'quad' ? 'active' : ''}`}
                        onClick={() => onViewModeChange('quad')}
                        aria-pressed={viewMode === 'quad'}
                        title="Quad view — up to four videos"
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                            <rect x="3" y="3" width="8" height="8" rx="1" ry="1"/>
                            <rect x="13" y="3" width="8" height="8" rx="1" ry="1"/>
                            <rect x="3" y="13" width="8" height="8" rx="1" ry="1"/>
                            <rect x="13" y="13" width="8" height="8" rx="1" ry="1"/>
                        </svg>
                        Quad
                    </button>
                </div>

                {!loggedIn && (
                    <div className="session-controls">
                    <button className="header-btn session-sign-in" type="button" onClick={handleLoginShow}>
                        Sign in
                    </button>
                    </div>
                )}
            </div>
        </header>
    );
};

export default ModernHeader;